import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const mobileMenuAction = (e) => {
    setIsMenuOpen(!isMenuOpen);
    handleNavClick(e);
  };

  // Funzione per il click su un elemento della navbar (scrolling graduale)
  const handleNavClick = (e) => {
    e.preventDefault(); // Impedisce il comportamento predefinito del link (navigazione immediata)

    const targetId = e.target.getAttribute("href").slice(1); // Estrae l'ID della sezione dalla URL
    const targetElement = document.getElementById(targetId); // Trova l'elemento della sezione

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" }); // Scorre alla sezione con animazione fluida
    }
  };

  return (
    <nav className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 fixed w-full z-20 top-0 left-0 py-2">
      <div className="flex justify-between items-center mx-auto w-full px-4">
        {/* Logo o nome del sito */}
        <div className="font-zerove text-lg flex-shrink-0">
          <picture>
            <source 
              srcSet="/images/galimberti-logo-mobile.png" 
              media="(max-width: 1023px)" 
            />
            <img
              src="/images/galimberti-logo.png"
              alt="Galimberti Rappresentanze"
              className="relative z-10 grayscale max-h-8 sm:max-h-10 md:max-h-12 lg:max-h-16 object-contain mx-auto opacity-100"
            />
          </picture>
        </div>


        <div className="flex items-center ml-auto lg:hidden">
          {/* Icona Instagram per mobile */}
          <a
            href="https://www.instagram.com/galimbertirappresentanze/"
            target="_blank"
            rel="noopener noreferrer"
            className="lg:hidden text-white text-xl hover:text-red-500 mr-4 transition-all duration-300"
          >
            <i className="fab fa-instagram"></i>
          </a>

          {/* Hamburger icon */}
            <button
              className="text-white hover:text-red-500 focus:outline-none"
              onClick={toggleMenu}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                />
              </svg>
            </button>
        </div>

        {/* Menu desktop */}
        <div className="hidden lg:flex absolute inset-x-0 top-0 h-full justify-center items-center">
          <ul className="flex space-x-8 text-white">
            <li>
              <a 
                href="#home" 
                className="text-xl hover:text-red-500 transition-all duration-300" 
                onClick={handleNavClick}
              >
                {t('navbar.home')}
              </a>
            </li>
            <li>
              <a 
                href="#about" 
                className="text-xl hover:text-red-500 transition-all duration-300" 
                onClick={handleNavClick}
              >
                {t('navbar.about')}
              </a>
            </li>
            <li>
              <a 
                href="#brands" 
                className="text-xl hover:text-red-500 transition-all duration-300" 
                onClick={handleNavClick}
              >
                {t('navbar.brands')}
              </a>
            </li>
            <li>
              <a 
                href="#services" 
                className="text-xl hover:text-red-500 transition-all duration-300" 
                onClick={handleNavClick}
              >
                {t('navbar.services')}
              </a>
            </li>
            <li>
              <a 
                href="#contact" 
                className="text-xl hover:text-red-500 transition-all duration-300" 
                onClick={handleNavClick}
              >
                {t('navbar.contact')}
              </a>
            </li>
            <li>
              <a 
                href="https://www.instagram.com/galimbertirappresentanze/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white-400 text-xl hover:text-red-500 transition-all duration-300"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>

        {/* LanguageSwitcher (desktop) */}
        <div className="hidden lg:block text-white hover:text-red-500 transition duration-300">
          <LanguageSwitcher />
        </div>
      </div>


      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="lg:hidden">
          <ul className="flex flex-col space-y-4 text-center text-lg text-white py-4">
            <li>
              <a
                href="#home"
                className="hover:text-red-500 transition duration-300"
                onClick={mobileMenuAction}
              >
                {t('navbar.home')}
              </a>
            </li>
            <li>
              <a
                href="#about"
                className="hover:text-red-500 transition duration-300"
                onClick={mobileMenuAction}
              >
                {t('navbar.about')}
              </a>
            </li>
            <li>
              <a
                href="#brands"
                className="hover:text-red-500 transition duration-300"
                onClick={mobileMenuAction}
              >
                {t('navbar.brands')}
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="hover:text-red-500 transition duration-300"
                onClick={mobileMenuAction}
              >
                {t('navbar.services')}
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="hover:text-red-500 transition duration-300"
                onClick={mobileMenuAction}
              >
                {t('navbar.contact')}
              </a>
            </li>
            <li>
              <div className="hover:text-red-500 transition duration-300">
                <LanguageSwitcher />
              </div>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
